<template>
	<div>
		<button
			v-if="!emailError && !emailSent"
			id="email-button"
			class="button stackng-button"
			type="button"
			@click="resendEmailVerification"
		>{{buttonText}}</button>
		<p v-if="emailSent" class="email-sent">
			<ion-icon name="checkmark"></ion-icon>Email sent!
		</p>
		<p v-if="emailError" class="email-error">
			<ion-icon name="ios-close"></ion-icon>Error, try again later
		</p>
	</div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";

export default {
	data() {
		return {
			emailSent: false,
			emailError: false,
		};
	},
	props: {
		from: {
			type: String,
		},
	},
	computed: {
		buttonText() {
			if (this.from === "groups" || this.from === "groups-modal") {
				return "Verify email to access groups";
			} else {
				return "Send verification email";
			}
		},
	},
	methods: {
		resendEmailVerification() {
			const button = document.querySelector("#email-button");
			button.classList.add("is-loading");

			setTimeout(() => {
				const authUser = firebase.auth().currentUser;
				authUser
					.sendEmailVerification()
					.then(() => {
						//Show toast
						this.$toasted.show(`Email sent`, {
							theme: "bubble",
							position: "bottom-center",
							duration: 2500,
						});

						this.emailSent = true;
						button.classList.remove("is-loading");
					})
					.catch((error) => {
						//Show toast
						this.$toasted.show(`Try again later`, {
							theme: "bubble",
							position: "bottom-center",
							duration: 2500,
							className: ["error-toast"],
						});

						this.emailError = true;
						button.classList.remove("is-loading");
					});
			}, 1000);
		},
		closeModal() {
			const html = document.querySelector("html");
			const modalContainer = document.querySelector(".modal-container");
			const app = document.querySelector("#app");
			app.classList.remove("blur-app");
			modalContainer.removeEventListener("click", this.closeModal);
			html.style.overflowY = "scroll";

			let payload = {
				show: false,
				action: "",
			};

			this.$store.commit("updateAccountModal", payload);
		},
	},
};
</script>

<style scoped>
.stackng-button {
	width: 100%;
	padding: 12px 20px;
	font-size: 15px;
	font-weight: 600;
}

.email-error {
	color: red;
	font-size: 15px;
}

.email-sent {
	color: #51c715;
	font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/buttons/EmailVerificationButton.vue